namespace SorAraBul.Definitions {
    export interface PetsForm {
        Name: Serenity.StringEditor;
    }

    export class PetsForm extends Serenity.PrefixedContext {
        static formKey = 'Definitions.Pets';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PetsForm.init)  {
                PetsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PetsForm, [
                    'Name', w0
                ]);
            }
        }
    }
}
